import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
const panelCss = "pg5yfws";
export const Panel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(panelCss, props.className)} />;
});
const panelSectionHasNoPaddingCss = "p16wn7z1";
const panelSectionIsInverseCss = "p4ljf8e";
const panelSectionCss = "p1adhibf";
export const PanelSection = forwardRef((props, ref) => {
  const {
    hasNoPadding,
    isInverse,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(panelSectionCss, {
    [panelSectionHasNoPaddingCss]: hasNoPadding,
    [panelSectionIsInverseCss]: isInverse
  }, props.className)} />;
});
PanelSection.propTypes = {
  isInverse: PropTypes.bool,
  hasNoPadding: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string
};

require("./panel.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./panel.js");